import $ from "jquery";
$(document).ready(function () {
    var ele = document.getElementById('order_header_tab');
    if ($(ele).length) {
        ele.style.cursor = 'grab';
        var pos_1 = { top: 0, left: 0, x: 0, y: 0 };
        var mouseDownHandler = function (e) {
            ele.style.cursor = 'grabbing';
            ele.style.userSelect = 'none';
            pos_1 = {
                left: ele.scrollLeft,
                top: ele.scrollTop,
                // Get the current mouse position
                x: e.clientX,
                y: e.clientY
            };
            document.addEventListener('mousemove', mouseMoveHandler_1);
            document.addEventListener('mouseup', mouseUpHandler_1);
        };
        var mouseMoveHandler_1 = function (e) {
            // How far the mouse has been moved
            var dx = e.clientX - pos_1.x;
            var dy = e.clientY - pos_1.y;
            // Scroll the element
            ele.scrollTop = pos_1.top - dy;
            ele.scrollLeft = pos_1.left - dx;
        };
        var mouseUpHandler_1 = function () {
            ele.style.cursor = 'grab';
            ele.style.removeProperty('user-select');
            document.removeEventListener('mousemove', mouseMoveHandler_1);
            document.removeEventListener('mouseup', mouseUpHandler_1);
        };
        // Attach the handler
        ele.addEventListener('mousedown', mouseDownHandler);
    }
});
